import { FlyerCategories } from '@/types/flyer';

import artsIcon from '@/assets/categories/community/arts-dark.svg';
import graduationCapIcon from '@/assets/categories/community/graduation-cap-dark.svg';
import familyActivitiesIcon from '@/assets/categories/community/family-activities.svg';
import darkIcon from '@/assets/categories/community/lamp-dark.svg';
import sportsIcon from '@/assets/categories/community/sports-dark.svg';
import healthIcon from '@/assets/categories/community/health-dark.svg';
import familyIcon from '@/assets/categories/community/family-dark.svg';
import serviceLearningIcon from '@/assets/categories/community/service-learning-dark.svg';

export const communityCategories: FlyerCategories = [
  {
    id: 'academics',
    title: 'Academics',
    icon: darkIcon,
  },
  {
    id: 'sports_and_recreation',
    title: 'Sports & Recreation',
    icon: sportsIcon,
  },
  {
    id: 'arts',
    title: 'Arts',
    icon: artsIcon,
  },
  {
    id: 'college_and_career',
    title: 'College & Career',
    icon: graduationCapIcon,
  },
  {
    id: 'family_activities_and_centers',
    title: 'Family Activities & Centers',
    icon: familyActivitiesIcon,
  },
  {
    id: 'health_and_safety',
    title: 'Health & Safety',
    icon: healthIcon,
  },
  {
    id: 'service_learning',
    title: 'Service Learning',
    icon: serviceLearningIcon,
  },
  {
    id: 'family_resources',
    title: 'Family Resources',
    icon: familyIcon,
  },
];
